import _Reflect$construct from "@babel/runtime-corejs3/core-js-stable/reflect/construct";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _get from "@babel/runtime-corejs3/helpers/get";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";
function ownKeys(e, r) {
  var t = _Object$keys(e);
  if (_Object$getOwnPropertySymbols) {
    var o = _Object$getOwnPropertySymbols(e);
    r && (o = _filterInstanceProperty(o).call(o, function (r) {
      return _Object$getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
function _createSuper(t) {
  var r = _isNativeReflectConstruct();
  return function () {
    var e,
      o = _getPrototypeOf(t);
    if (r) {
      var s = _getPrototypeOf(this).constructor;
      e = _Reflect$construct(o, arguments, s);
    } else e = o.apply(this, arguments);
    return _possibleConstructorReturn(this, e);
  };
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function () {
    return !!t;
  })();
}
import { isExists as doesDateExist, isValid } from "date-fns";
import isEmpty from "lodash/isEmpty";
import isNil from "lodash/isNil";
import { isEmptyValue } from "@jutro/data";
import { formatDateToLocalePattern, isDateInRange, parseDateFromDataType } from "@jutro/locale";
import { getMessageProp } from "@jutro/platform";
import { OldFieldComponentValidationImplementation } from "../../FieldComponent/OldFieldComponentValidationImplementation";
import { messages } from "../DateField/DateField.messages";
export var OldSimpleDateFieldValidationImplementation = function (_OldFieldComponentVal) {
  _inherits(OldSimpleDateFieldValidationImplementation, OldFieldComponentValidationImplementation);
  var _super = _createSuper(OldSimpleDateFieldValidationImplementation);
  function OldSimpleDateFieldValidationImplementation() {
    return _classCallCheck(this, OldSimpleDateFieldValidationImplementation), _super.apply(this, arguments);
  }
  return _createClass(OldSimpleDateFieldValidationImplementation, [{
    key: "bind",
    value: function (entityToBind) {
      var _this = this,
        superBoundMethods = _get(_getPrototypeOf(OldSimpleDateFieldValidationImplementation.prototype), "bind", this).call(this, entityToBind),
        methods = ["getValidationMessages"];
      return _reduceInstanceProperty(methods).call(methods, function (acc, method) {
        return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, method, _this[method].bind(entityToBind)));
      }, superBoundMethods);
    }
  }, {
    key: "getValidationMessages",
    value: function () {
      var _this$props = this.props,
        minDate = _this$props.minDate,
        maxDate = _this$props.maxDate,
        messageProps = _this$props.messageProps,
        displayFormat = _this$props.displayFormat,
        intl = _this$props.intl,
        translator = this.translator,
        value = this.getValue(),
        validationMessages = _get(_getPrototypeOf(OldSimpleDateFieldValidationImplementation.prototype), "getValidationMessages", this).call(this, value) || [];
      if (isEmptyValue(value)) return validationMessages;
      if (!isEmpty(validationMessages)) return validationMessages;
      var incorrectInput = getMessageProp("incorrectInput", messageProps, messages),
        validationMinDate = getMessageProp("validationMinDate", messageProps, messages),
        validationMaxDate = getMessageProp("validationMaxDate", messageProps, messages);
      if (value instanceof Object) {
        var day = value.day,
          month = value.month,
          year = value.year;
        if (isNil(day) || isNil(month) || isNil(year) || !doesDateExist(year, month, day)) return [translator(incorrectInput)];
      }
      var date = parseDateFromDataType(value);
      if (!isValid(date)) return [translator(incorrectInput)];
      var _isDateInRange = isDateInRange(date, minDate, maxDate),
        fulfillMinRequirement = _isDateInRange.fulfillMinRequirement,
        fulfillMaxRequirement = _isDateInRange.fulfillMaxRequirement;
      return !fulfillMinRequirement && minDate ? [translator(validationMinDate, {
        minDate: formatDateToLocalePattern(parseDateFromDataType(minDate), null == intl ? void 0 : intl.formatDate, displayFormat, this.getInputFormat())
      })] : !fulfillMaxRequirement && maxDate ? [translator(validationMaxDate, {
        maxDate: formatDateToLocalePattern(parseDateFromDataType(maxDate), null == intl ? void 0 : intl.formatDate, displayFormat, this.getInputFormat())
      })] : validationMessages;
    }
  }]), OldSimpleDateFieldValidationImplementation;
}();